module.exports = "<div class=\"kan-editor\">\n    <ckeditor [(ngModel)]=\"value\"\n              [config]=\"{}\"\n              (change)=\"onChange($event)\"\n              debounce=\"500\">\n    </ckeditor>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/components/editor/component.html
// module id = ./src/modules/common/components/editor/component.html
// module chunks = main